<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">THE PIRATE WHO STOLE SCOTLAND</h1>
<p class="subtitle">WILLIAM DAMPIER AND THE CREATION OF THE UNITED KINGDOM</p>
<p class="author">LEON HOPKINS</p>
<div class="img_containert">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Title.vue?64c56072